import React from 'react';
import { BaseComponent, IStateBase } from 'components/BaseComponent';
import { cartService } from 'services/CartService';
import { IProductData } from 'interfaces/IProductData';
import { CurrencyFormat } from 'components/CurrencyFormat';
import Translate from 'components/Translate';

const styles = require('./couponPrice.css');

interface IState extends IStateBase {
  cart: IProductData;
}

export default class CouponPrice extends BaseComponent<IState> {
  constructor(props: any) {
    super(props);
  }

  componentDidMount() {
    this.observeState({ cart: null }, cartService.getCart());
  }

  render() {
    if (!this.state) {
      return null;
    }

    const { cart } = this.state;

    if (!cart.coupon) {
      return null;
    }

    return (
      <div className={`${styles.component} chk-couponPrice`}>

        <Translate
          term='De {realPrice} por'
          properties={{
            realPrice: <CurrencyFormat value={cart.realPrice + cart.realTax} />
          }}
        />
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/Cart/Coupon/CouponPrice/index.tsx